import {createSelector} from 'reselect';

import ModalTypes from '../../enums/app/modalTypes';
import {IRootState} from '../state';

const selectModal = (state: IRootState) => state.modal;

const selectGlobalModals = createSelector(selectModal, (modalState) => modalState.globalModals);
const selectRenderedModals = createSelector(selectModal, (modalState) => modalState.renderedModals);

const makeSelectVisibleGlobalModal = (modalType: ModalTypes): any =>
    createSelector(selectGlobalModals, (modalState) => modalState.some((modal) => modal.modalType === modalType));

const makeSelectGlobalModal = (modalType: ModalTypes): any =>
    createSelector(selectGlobalModals, (modalState) => modalState.find((modal) => modal.modalType === modalType));

const makeSelectIsVisibleRenderedModal = (id: string): any =>
    createSelector(selectRenderedModals, (modals) => {
        const lastModalId = modals.length ? modals[modals.length - 1] : null;

        return lastModalId === id;
    });

const selectIsAnyRenderedPopup = createSelector(selectRenderedModals, (modals) => !!modals?.length);

export {
    makeSelectGlobalModal,
    makeSelectIsVisibleRenderedModal,
    makeSelectVisibleGlobalModal,
    selectGlobalModals,
    selectIsAnyRenderedPopup,
};
